<template>
  <div class="attention_field">
      <div class="field_checked" v-if="group_subscribe.length > 0">
          <div class="checked">
              <div class="checked1">
                  已关注
              </div>
              <div class="checked3">
                  <a v-if="!all_show && group_subscribe.length > 10" @click="showMore">更多<i class="iconfont">&#xe648;</i></a>
                  <a v-if="all_show && group_subscribe.length > 10" @click="showMore">收起<i class="iconfont">&#xe63b;</i></a>
              </div>
          </div>
          <div class="checked2">
              <div class="tag_loading" v-if="tag_loading">
                <Spin fix>
                    <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                </Spin>
              </div>
              <Dropdown
                  class="cancel"
                  placement="bottom-start"
                  v-for="(item,index) in show_group_subscribe"
                  :key="item.id"
                  @on-click="deleteConfirm($event, item.id)"
              >
                  <span class="span_tag"><i class="iconfont">&#xe64b;</i>{{item.sub_type_id | dealName(entity_ntag)}}</span>
                  <DropdownMenu slot="list">
                      <DropdownItem name="move">移除分组</DropdownItem>
                      <DropdownItem name="cancel">取消关注</DropdownItem>
                  </DropdownMenu>
              </Dropdown>
          </div>
      </div>
      <div class="field_options">
          <div class="title">热门推荐<span @click="handleChangePage" v-if="recommend_tag_map.length > 36"><i class="iconfont">&#xe65d;</i>换一批</span></div>
          <div class="tags-list">
              <div class="span_tag" v-for="item,index in show_options">
                  <Dropdown
                      class="cancel"
                      placement="bottom-start"
                      v-if="group_subscribe.findIndex((a) => a.sub_type_id == item.id) > -1"
                      @on-click="deleteConfirm($event, group_subscribe[group_subscribe.findIndex((a) => a.sub_type_id == item.id)].id)"
                  >
                      <span>
                          <i class="iconfont active">&#xe64b;</i>
                          <i class="tag-name">{{item.name}}</i>
                      </span>
                      <DropdownMenu slot="list">
                          <DropdownItem name="move">移除分组</DropdownItem>
                          <DropdownItem name="cancel">取消关注</DropdownItem>
                      </DropdownMenu>
                  </Dropdown>
                  <span v-else @click="fieldChecked(item.id)" class="defalut">
                      <i class="iconfont">&#xe64a;</i>
                      <i class="tag-name">{{item.name}}</i>
                  </span>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { attention_mixins } from 'js/attention_mixins'
import { addSubscribe,deleteSubscribe } from '../../../service'

export default {
  name: 'AttentionField',
  mixins: [attention_mixins],
  props: ['selGroupId'],
  computed: {
    group_subscribe() {
      const g_subscribe_index = []
      const g_subscribe = []
      this.attention.g_relation.map((a) => {
        if(this.selGroupId == a.group_id){
          g_subscribe_index.push(a.subscribe_id)
        }
      })
      // console.log(g_subscribe_index)
      g_subscribe_index.map((a)=> {
        this.attention.subscribe.map((b) => {
          if(b.id == a && b.sub_type == '2'){
            g_subscribe.push({
              create_time: b.create_time,
              id: b.id,
              sub_type: b.sub_type,
              sub_type_id: b.sub_type_id,
            })
          }
        })
      })
      this.tag_loading = false
      this.clear_loading = false
      // console.log(this.show_group_subscribe)
      if(this.all_show){
        this.show_group_subscribe = g_subscribe
      }else{
        this.show_group_subscribe = g_subscribe.slice(0, 10)
      }
      return g_subscribe
    },
    show_options() {
      return this.recommend_tag_map.slice((this.page - 1) * 36, this.page * 36)
    }
  },
  data () {
    return {
      all_show: false,
      tag_loading: false,
      clear_loading: false,
      show_group_subscribe: [],
      page: 1
    }
  },
  methods: {
    async fieldChecked (val) {
      if(!this.tag_loading){
        this.tag_loading = true
        const add_tag = {
          sub_type: '2',
          sub_type_id: val,
          group_id: [this.selGroupId],
          user_key: this.user_key
        }
        // this.moveArr(val)
        let res = await addSubscribe(add_tag, (error) => {
          this.$Message.error('请求错误！')
        })
        if(res.status == 'success') {
          this.getSubscribeList()
        } else {
          console.log(res)
        }
      }else{
        this.$Message.loading("添加中，请勿重复操作！")
      }
    },
    deleteConfirm(name, val) {
      const _that = this
      let tip = ''
      if(name == "cancel") {
        tip = '确定不再关注？<br />取消关注，其他分组同步取消哦~'
      }else{
        tip = '确认移除分组？<br />移除分组，仅移除当前分组，不影响其他分组。'
      }
      layer.confirm(tip, {
        title: false,
        offset: '100px',
        skin: 'layer-custom',
        btn: ['确定','取消'] //按钮
      }, function(){
        _that.clearAttention(name,val)
        layer.closeAll()
      }, function(){
        layer.closeAll()
      })
    },
    async clearAttention(name,val) {
      if(!this.clear_loading) {
        this.clear_loading = true
        let del_group = {}
        if(name == "cancel") {
          del_group = {
            op_type: 'cancel',
            subscribe_id: val,
            user_key: this.user_key
          }
        }else{
          del_group = {
            op_type: 'move',
            subscribe_id: val,
            group_id: this.selGroupId,
            user_key: this.user_key
          }
        }
        // console.log(del_group)
        let res = await deleteSubscribe(del_group, (error) => {
          this.$Message.error('请求错误！')
        })
        if(res.status == 'success') {
          const _that = this
          this.getSubscribeList(_that.$Message.success('取消成功！'))
        } else {
          this.$Message.error(res.message)
        }
      }else{
        this.$Message.loading("删除中，请勿重复操作！")
      }
    },
    showMore() {
      this.all_show = !this.all_show
      if(this.all_show){
        this.show_group_subscribe = this.group_subscribe
      }else{
        this.show_group_subscribe = this.group_subscribe.slice(0, 10)
      }
    },
    handleChangePage() {
      let max_page = Math.ceil(this.recommend_tag_map.length / 36)
      if(this.page == max_page) {
        this.page = 1
      } else {
        this.page ++
      }
    }
    // async moveArr(val) {
    //   let p_arr = [], move_arr = []
    //
    //   this._dynview_tag.map((a) => {
    //     if(a.pid == val || a.pgid == val){
    //       p_arr.push(a.id)
    //     }
    //   })
    //
    //   p_arr.map((a) => {
    //     let move_obj = this.group_subscribe.find((b) => b.sub_type_id == a)
    //     if(move_obj){
    //       move_arr.push(move_obj.id)
    //     }
    //   })
    //
    //   if(move_arr.length > 0){
    //     let del_group = {
    //       op_type: 'movemore',
    //       subscribe_id: move_arr,
    //       group_id: this.selGroupId,
    //       user_key: this.user_key
    //     }
    //
    //     let res = await deleteSubscribe(del_group, (error) => {
    //       this.$Message.error('请求错误！')
    //     })
    //     if(res.status == 'success') {
    //       this.getSubscribeList()
    //     } else {
    //       this.$Message.error(res.message)
    //     }
    //   }
    //
    // }
  },
  created() {
    this.getMeta()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/attention.stylus'
</style>
